import { Box, TextFieldProps } from "@mui/material";
import { DateRange, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { FieldProps, useFormikContext } from "formik";
import React from "react";
import { DateRangePicker } from "@mui/x-date-pickers-pro";

interface Props {
  handleChange?: (value: DateRange<Date>) => void;
}

const FormikDateRangePicker: React.FC<FieldProps & TextFieldProps & Props> = (
  props
) => {
  const {
    handleChange: onDateSelected,
    helperText,
    error,
    field,
    ...rest
  } = props;
  const { setFieldValue } = useFormikContext();

  const handleChange = (value: any) => {
    setFieldValue(props.field.name, value);
    onDateSelected?.(value);
  };

  return (
    <Box sx={{ pb: "20px" }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateRangePicker
          calendars={2}
          value={field.value || [null, null]}
          onChange={handleChange}
          label={props.label}
          slotProps={{ textField: { ...rest, fullWidth: true } }}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default FormikDateRangePicker;
